export default __webpack_public_path__ + "static/media/5.996ab42f.jpg";